import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { Textarea } from "@/components/ui/textarea";
import { Body } from "@hypercard/web-components";
import { useState } from "react";

interface Props {
  onConfirm: (notes?: string) => void;
  isLoading: boolean;
  isRequired: boolean;
  textareaPlaceholder: string;
  title: string;
  description: string;
  renderTrigger: () => JSX.Element;
}

export const ApproveOrRejectDialog = ({
  onConfirm,
  isLoading,
  isRequired,
  textareaPlaceholder,
  description,
  title,
  renderTrigger,
}: Props) => {
  const [notes, setNotes] = useState("");

  const handleConfirm = () => {
    onConfirm(notes || undefined);
  };

  const handleOpenChange = (open: boolean) => {
    if (!open) setNotes("");
  };

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setNotes(e.target.value);
  };

  return (
    <Dialog onOpenChange={handleOpenChange}>
      <DialogTrigger asChild>{renderTrigger()}</DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        <DialogDescription>{description}</DialogDescription>
        <div className="mt-6 w-full">
          <div className="mb-3 flex w-full flex-grow justify-between">
            <Body size="sm" weight="regular" className="text-white/70">
              Reason
            </Body>
            <Body size="sm" weight="regular" className="text-white/70">
              {isRequired ? "Required" : "Optional"}
            </Body>
          </div>
          <Textarea
            value={notes}
            placeholder={textareaPlaceholder}
            onChange={handleChange}
          />
        </div>
        <DialogFooter>
          <DialogClose disabled={isLoading} asChild>
            <Button
              type="button"
              variant="ghost"
              disabled={isLoading}
              className="min-w-36"
            >
              Cancel
            </Button>
          </DialogClose>
          <DialogClose disabled={isLoading || (isRequired && !notes)} asChild>
            <Button
              type="button"
              variant="default"
              disabled={isLoading || (isRequired && !notes)}
              onClick={handleConfirm}
              className="min-w-36"
            >
              Confirm
            </Button>
          </DialogClose>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
